module.exports = __webpack_public_path__ + "img/KarstenRau_140x140_rund.2304d770.jpg";